export enum ColorUtils {
  ENSOLVERS_ORANGE = "#F59E33",
  ENSOLVERS_ORANGE_REBRANDING = "#FF6F00",
  STRONG_ENSOLVERS_ORANGE = "#FF9800",
  ENSOLVERS_SECONDARY = "#FFFF00",
  DANGER = "#EA9999",
  WARNING = "#FFE599",
  SUCCESS = "#DDFFDD",
  DARK_OOO = "#000",
  LIGHT_GRAY = "#D3D3D3",
  LIGHTER_GRAY = "#E6E6E8",
  LIGHT_BLUE = "#D0E0E3",
  BLUE = "#CCEEFF",
  LIGHT_YELLOW = "#FFF2CC",
  LIGHT_ORANGE = "#FFDDAD",
  LIGHT_RED = "#F7C8D1",
  LIGHT_GREEN = "#DDFFDD",
  BTN_TEXT_CONFIRM = "#1976D2",
  MEDIUM_GRAY = "#9F9F9F",
  CHECKBOX_DEFAULT = "#B1AEAE",
  CHECKBOX_YELLOW = "#FFD167",
  CHECKBOX_RED = "#E65A75",
  CHECKBOX_GREEN = "#99FF99",
  CHECKBOX_BLUE = "#3CB4FB",
  TABLE_HEADER = "#FAFBFC",
  TABLE_BORDER = "#E6E6E8",
  FONT_LIGHT_GRAY = "#5F5F5F",
  BLUE_LINK = "#0E00EE",
  WHITE = "#FFFFFF",
}
